var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLvl1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 211.74 277.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient-6);}.cls-4{fill:url(#linear-gradient-11);}.cls-5{fill:url(#linear-gradient-10);}.cls-6{fill:#343652;}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient);}.cls-12{fill:url(#linear-gradient-4);}.cls-13{fill:url(#linear-gradient-8);}.cls-14{fill:url(#linear-gradient-12);}.cls-15{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 98.31,
    y1: 70.37,
    x2: 98.31,
    y2: 229.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 127.25,
    y1: 70.37,
    x2: 127.25,
    y2: 229.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 127.26,
    y1: 70.37,
    x2: 127.26,
    y2: 229.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 127.26,
    y1: 70.37,
    x2: 127.26,
    y2: 229.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 127.25,
    y1: 70.37,
    x2: 127.25,
    y2: 229.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 127.25,
    y1: 70.37,
    x2: 127.25,
    y2: 229.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 127.25,
    y1: 70.37,
    x2: 127.25,
    y2: 229.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 127.25,
    y1: 70.37,
    x2: 127.25,
    y2: 229.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 127.25,
    y1: 70.37,
    x2: 127.25,
    y2: 229.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 127.25,
    y1: 70.37,
    x2: 127.25,
    y2: 229.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 3.96,
    y1: 225.08,
    x2: 99.19,
    y2: 166.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9cf2f",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9cf2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 206.77,
    y1: 112.54,
    x2: 10.5,
    y2: 226.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bb95",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41bb95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -5.15,
    y1: 171.19,
    x2: 55.76,
    y2: 171.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f05a26",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05a26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 105.87,
    cy: 171.19,
    r: 105.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 105.87,
    cy: 171.19,
    r: 90.97
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M116.51,131.14v80.11h-23.49v-61.96h-12.92v-18.15h36.41Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.44,201.73h2v5.94h-8.37v-5.84h1.99v3.34h1.23v-3h1.89v3h1.25v-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M128.73,200.21v-2.59c.6,0,.89-.5,.89-1.07,0-.53-.26-1.03-.71-1.03-.53,0-.68,.71-.87,1.58-.3,1.32-.67,3-2.58,3-1.65,0-2.59-1.32-2.59-3.47s1.03-3.44,2.73-3.44v2.52c-.53,0-.78,.43-.78,.95,0,.45,.18,.88,.57,.88,.48,0,.63-.69,.83-1.55,.32-1.34,.73-3.1,2.64-3.1s2.78,1.53,2.78,3.65c0,2.23-1.08,3.67-2.91,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M128.73,191.5v-2.59c.6,0,.89-.5,.89-1.07,0-.53-.26-1.03-.71-1.03-.53,0-.68,.71-.87,1.58-.3,1.32-.67,3-2.58,3-1.65,0-2.59-1.32-2.59-3.47s1.03-3.44,2.73-3.44v2.52c-.53,0-.78,.43-.78,.95,0,.45,.18,.88,.57,.88,.48,0,.63-.69,.83-1.55,.32-1.34,.73-3.1,2.64-3.1s2.78,1.53,2.78,3.65c0,2.23-1.08,3.67-2.91,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M129.44,176.4h2v5.95h-8.37v-5.84h1.99v3.33h1.23v-2.99h1.89v2.99h1.25v-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.07,166.3h8.37v2.08l-4.54,3.62h4.54v2.44h-8.37v-2.2l4.39-3.5h-4.39v-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M125.14,157.18v2.48h6.29v2.52h-6.29v2.48h-2.08v-7.48h2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M123.07,155.55v-2.55h8.37v2.55h-8.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M130.08,145.17v3.23l1.36,.51v2.69l-8.37-3.58v-2.46l8.37-3.66v2.77l-1.36,.5Zm-4.4,1.62l2.59,1v-2.01l-2.59,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M129.33,134.71h2.11v5.79h-8.37v-2.55h6.26v-3.25Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.53,207.77c-3.8-5.23-6.81-11.06-8.85-17.34-1.97-6.06-3.04-12.52-3.04-19.23H0C0,182.62,1.83,193.6,5.18,203.91c3.47,10.68,8.59,20.61,15.06,29.5,6.53,8.98,14.44,16.88,23.42,23.42l25.65-35.3c-5.28-3.84-9.92-8.49-13.77-13.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M206.56,138.48c-3.47-10.68-8.59-20.61-15.06-29.5-6.53-8.98-14.44-16.88-23.42-23.42-8.89-6.47-18.82-11.59-29.5-15.06-10.31-3.35-21.3-5.18-32.72-5.18s-22.41,1.83-32.72,5.18c-10.68,3.47-20.61,8.59-29.5,15.06-8.98,6.53-16.88,14.44-23.42,23.42-6.47,8.89-11.59,18.82-15.06,29.5C1.83,148.78,0,159.77,0,171.19H43.64c0-6.71,1.08-13.17,3.04-19.23,2.04-6.28,5.05-12.12,8.85-17.34,3.84-5.28,8.49-9.92,13.77-13.77,5.23-3.8,11.06-6.81,17.34-8.85,6.06-1.97,12.52-3.04,19.23-3.04s13.17,1.08,19.23,3.04c6.28,2.04,12.12,5.05,17.34,8.85,5.28,3.84,9.92,8.49,13.77,13.77,3.8,5.23,6.81,11.06,8.85,17.34,1.97,6.06,3.04,12.52,3.04,19.23s-1.08,13.17-3.04,19.23c-2.04,6.28-5.05,12.12-8.85,17.34-3.84,5.28-8.49,9.92-13.77,13.77-5.23,3.8-11.06,6.81-17.34,8.85-6.06,1.97-12.52,3.04-19.23,3.04s-13.17-1.08-19.23-3.04c-6.28-2.04-12.12-5.05-17.34-8.85l-25.65,35.3c8.89,6.47,18.82,11.59,29.5,15.06,10.31,3.35,21.3,5.18,32.72,5.18s22.41-1.83,32.72-5.18c10.68-3.47,20.61-8.59,29.5-15.06,8.98-6.53,16.88-14.44,23.42-23.42,6.47-8.89,11.59-18.82,15.06-29.5,3.35-10.31,5.18-21.3,5.18-32.72s-1.83-22.41-5.18-32.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0,
    y: 170.14,
    width: 43.64,
    height: 2.11
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.59,36.93h14.51v8.55H21.51V0h11.08V36.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.2,8.88v9.2h14.84v8.55h-14.84v9.98h16.78v8.88h-27.86V0h27.86V8.88h-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.58,0l-16.13,45.49h-13.87L81.44,0h11.79l11.27,34.34L115.85,0h11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.96,8.88v9.2h14.84v8.55h-14.84v9.98h16.78v8.88h-27.86V0h27.86V8.88h-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.72,36.93h14.51v8.55h-25.59V0h11.08V36.93Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvl1);
export default __webpack_public_path__ + "static/media/lvl1.3f024da7ef49db5e74b6d23c7ab48d48.svg";
export { ForwardRef as ReactComponent };